<app-header *ngIf="isVisible"></app-header>
<app-sidebar *ngIf="isVisible"></app-sidebar>
<app-right-sidebar></app-right-sidebar>
<div [dir]="direction">
  <router-outlet></router-outlet>
</div>
